<template>
  <div>
    <a-spin size="large" :spinning="loading_detable" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <!-- <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input> -->
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        header-align="center"
      >
        <vxe-column
          field="genename"
          title="Perturbed gene"
          type="html"
        ></vxe-column>
        <vxe-column
          field="datasetId"
          title="Dataset ID"
          type="html"
        ></vxe-column>
        <vxe-column
          field="primer"
          title="sgRNA ID"
          type="html"
          width="20%"
        ></vxe-column>
        <vxe-column
          field="tsequence"
          title="Protospacer sequence"
          type="html"
          width="40%"
        >
          <template #default="{ row }">
            {{ row.tsequence }}
            <a-icon
              type="copy"
              class="copy-btn"
              :data-clipboard-text="`${row.tsequence}`"
              @click="copyEvents(row.tsequence)"
            />
          </template>
        </vxe-column>
        <!-- <vxe-column field="copy" title="Copy" type="html">
        </vxe-column> -->
        <vxe-column field="Year" title="Year" type="html"></vxe-column>
        <vxe-column field="article" title="Article" type="html">
          <template #default="{ row }">
            <a
              type="button"
              class="downloadbutton"
              @click="goNCBI(row.article)"
              target="_black"
              style="color: black; border-radius: 5px"
            >
              {{ row.article }}
            </a>
          </template>
        </vxe-column>
        <template #empty>
          <span style="color: grey"> No records found! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[20, 50]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
import Clipboard from "clipboard";

export default {
  props: ["gene"],
  // components: { Clipboard },
  data() {
    return {
      //相关性分析
      corModal: false,
      gene1: "",
      gene2: this.$route.query.gene,
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: true,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  mounted() {
    new Clipboard(".copy-btn");
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/searchPrimers.php",
        {
          params: {
            gene: this.$route.query.gene,
            datasetId: this.$route.query.datasetId,
          },
        }
      )
      .then((response) => {
        this.getdata_detable = response.data;
        this.findList_detable(this.getdata_detable);
        this.loading_detable = false;
      });
  },

  methods: {
    goNCBI(value) {
      const href = "https://pubmed.ncbi.nlm.nih.gov/" + value;
      window.open(href);
    },
    copyEvents(value) {
      this.$notification.open({
        message: "Successfully copied " + value + " to the clipboard.",
        icon: <a-icon type="smile" style="color: seagreen" />,
        top: "100px",
      });
    },
    exportDataEvent() {
      const list = this.getdata_detable;
      this.$refs.xTable.exportData({
        filename: "PerturbDB_Collected_Primers_for_" + this.gene,
        type: "txt",
        isHeader: true,
        isFooter: true,
        data: list,
      });
    },
    goBulkPerturbgene(value, vaule2) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=" +
        value +
        "&gene=" +
        vaule2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "genename",
          // "ensgID",
          "datasetId",
          "primer",
          "tsequence",
        ];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}

.copy-btn {
  cursor: pointer;
  background-color: #f0f0f0;
  border: none;
  padding: 5px;
  border-radius: 4px;
}
.copy-btn:hover {
  background-color: #e2e2e2;
}
</style>
